import React, { useEffect, useState, useRef } from 'react'
import styles from "./influencers.module.css";
import { InfluencerAchived, InfluencerBanner, InfluencerBecomeMaster, InfluencerFirstSec, InfluencerHighlights, InfluencerSecondSec, Loading } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { useSelect } from '@react-three/drei';
import { fetchConfigData } from '../../slice/configSlice';
import { fetchPartnerData } from '../../slice/partnerSlice';
import { fetchInfluencerDetails } from '../../slice/influencerSlice';
import VideoPopup from '../../components/videoPopup/VideoPopup';

const Influencers = () => {
    const [isContentLoaded, setIsContentLoaded] = useState(false);

    const dispatch = useDispatch();
    const { config: { data: configData, loading, error }, partner: { data: partnerData }, influencer: { data: influencerData }, } = useSelector((state) => ({
        config: state.config,
        partner: state.partner,
        influencer: state.influencer
    }));

    useEffect(() => {
        dispatch(fetchConfigData());
        dispatch(fetchPartnerData());
        dispatch(fetchInfluencerDetails());
    }, [dispatch]);

    useEffect(() => {
        console.log('Config data : ', configData);
        console.log('partner Data : ', partnerData);
        console.log("Influencer Data : ", influencerData);
    }, [configData, partnerData, influencerData]);

    const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);
    const [currentVideoSrc, setCurrentVideoSrc] = useState('');
    const videoPopupRef = useRef(null);
    const popupVideoRef = useRef(null);
    const videoRef = useRef(null);

    const handlePlayClick = (videoSrc) => {
        setCurrentVideoSrc(videoSrc);
        const currentVideo = videoRef.current;
        if (currentVideo) {
            //setVideoCurrentTime(currentVideo.currentTime);  // Store the current time of the video when clicked
        }
        setIsVideoPopupOpen(true);
    };

    const handleCloseClick = () => {
        setIsVideoPopupOpen(false);
    };


    return (

        <>
            {loading && <Loading />}

            {!loading && (
                <section className={styles.influencerSec}>
                    {/* <InfluencerBanner configData={configData} /> */}
                    <InfluencerFirstSec configData={configData} />
                    <InfluencerAchived influencerData={influencerData.influencer} />
                    <InfluencerHighlights influencerData={influencerData} handlePlayClick={(videoSrc) => handlePlayClick(videoSrc)} />
                    <InfluencerSecondSec partnerData={partnerData} influencerData={influencerData.influencer} />
                    <InfluencerBecomeMaster influencerData={influencerData.influencer} />
                </section>
            )}


            {isVideoPopupOpen && (
                <VideoPopup videoPopupRef={videoPopupRef} handleCloseClick={handleCloseClick} popupVideoRef={popupVideoRef} currentVideoSrc={currentVideoSrc}/>

            )}

        </>

    )
}

export default Influencers
